const Reflux = require('@muzzylane/reflux');

const ServerRequest = require('./request');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');

const GlobalFeaturedDemoActions = Reflux.createActions({
    getAll: { children: ['completed', 'failed'] },
    add: { children: ['completed', 'failed'] },
    update: { children: ['completed', 'failed'] },
    delete: { children: ['completed', 'failed'] },
});

GlobalFeaturedDemoActions.getAll.listen(function(actionId, params={}) {
    ServerRequest.makeRequest(`/authoring/featured_demos${!!params.all ? '?all=true' : ''}`, 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

GlobalFeaturedDemoActions.add.listen(function(actionId, params) {
    if (!params.novaActId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const body = { nova_act_id: params.novaActId };
    if (params.expiresAt) {
        body.expires_at = params.expiresAt;
    }

    ServerRequest.makeRequest('/authoring/featured_demos', 'PUT', JSON.stringify(body))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

GlobalFeaturedDemoActions.update.listen(function(actionId, params) {
    if (!params.id) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const body = {};
    if (params.expiresAt) {
        body.expires_at = params.expiresAt;
    }

    if (typeof params.enabled === 'boolean') {
        body.enabled = params.enabled;
    }

    ServerRequest.makeRequest(`/authoring/featured_demos/${params.id}`, 'PATCH', JSON.stringify(body))
        .then(res => this.completed(actionId, params.id, res))
        .catch(err => this.failed(actionId, params.id, err));
});

GlobalFeaturedDemoActions.delete.listen(function(actionId, params) {
    if (!params.id) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/featured_demos/${params.id}`, 'DELETE')
        .then(res => this.completed(actionId, params.id, res))
        .catch(err => this.failed(actionId, params.id, err));
});

module.exports = GlobalFeaturedDemoActions;